import React, { useEffect, useState } from "react";
import { Save, Mail, Phone, Building2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminSettings() {
  const [s, setS] = useState({ company_name: "", hr_email: "", hr_phone: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/admin/settings");
        setS({
          company_name: r.data.company_name || "",
          hr_email: r.data.hr_email || "",
          hr_phone: r.data.hr_phone || "",
        });
      } catch (e) { toast.error("Failed to load settings"); }
      finally { setLoading(false); }
    })();
  }, []);

  const save = async () => {
    if (saving) return;
    if (!s.hr_email || !/.+@.+\..+/.test(s.hr_email)) { toast.error("Enter a valid HR email"); return; }
    setSaving(true);
    try {
      await api.put("/admin/settings", s);
      toast.success("Settings saved");
    } catch (e) { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  if (loading) return <div className="text-zinc-500">Loading…</div>;

  return (
    <div className="max-w-3xl">
      <h1 className="font-display text-4xl font-bold tracking-tight">Settings</h1>
      <p className="text-zinc-500 mt-2">HR contact details shown to locked candidates on the Account Locked screen.</p>

      <div className="card-clean p-6 mt-8 space-y-5">
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-2"><Building2 size={12} /> Company Name</label>
          <input
            data-testid="settings-company-name"
            value={s.company_name}
            onChange={(e) => setS({ ...s, company_name: e.target.value })}
            className="mt-2 w-full px-4 py-3 rounded-xl border border-[var(--line)] focus:border-[var(--accent)] outline-none"
            placeholder="DataSprint"
          />
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-2"><Mail size={12} /> HR Email <span className="text-rose-600">*</span></label>
          <input
            data-testid="settings-hr-email"
            type="email"
            value={s.hr_email}
            onChange={(e) => setS({ ...s, hr_email: e.target.value })}
            className="mt-2 w-full px-4 py-3 rounded-xl border border-[var(--line)] focus:border-[var(--accent)] outline-none"
            placeholder="hr@datasprint.in"
          />
          <div className="text-[11px] text-zinc-500 mt-1">Candidates can email this address from the lock screen.</div>
        </div>

        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-2"><Phone size={12} /> HR Phone <span className="text-zinc-400 font-normal normal-case tracking-normal">(optional)</span></label>
          <input
            data-testid="settings-hr-phone"
            value={s.hr_phone}
            onChange={(e) => setS({ ...s, hr_phone: e.target.value })}
            className="mt-2 w-full px-4 py-3 rounded-xl border border-[var(--line)] focus:border-[var(--accent)] outline-none"
            placeholder="+91 90000 00000"
          />
          <div className="text-[11px] text-zinc-500 mt-1">Leave empty to hide the phone button on the lock screen.</div>
        </div>

        <div className="pt-2">
          <button
            data-testid="settings-save-btn"
            onClick={save}
            disabled={saving}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[var(--ink)] text-white text-sm font-semibold hover:bg-[var(--accent)] disabled:opacity-50"
          >
            <Save size={14} /> {saving ? "Saving…" : "Save Settings"}
          </button>
        </div>
      </div>
    </div>
  );
}
